import React from "react";

const Department = () => {
  return (
    <div className="container my-4">
      <h2 className="display-5 fw-bold mb-3">🏫 Departments</h2>
      <ul>
        <li>Misbahi Darul Ifta</li>
        <li>Misbahi Darul Musannifeen</li>
        <li>Jamiyah Murtahiyah Asharul Uloom</li>
        <li>5 Years Aalim Class</li>
        <li>Darul Hifz</li>
        <li>Misbahi Talimunnisa</li>
        <li>IT & Social Media Dept</li>
        <li>Widows Help</li>
        <li>Students Pocket Cost</li>
        <li>Masjid Construction</li>
        <li>Online Academy</li>
      </ul>
    </div>
  );
};

export default Department;
